import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { CheckCircle, Loader2 } from 'lucide-react';
import api from '@/utils/api';

export default function AssessmentComplete() {
  const { token } = useParams();
  const [candidate, setCandidate] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadCandidateInfo();
  }, [token]);

  const loadCandidateInfo = async () => {
    try {
      const response = await api.post('/invites/validate', null, {
        params: { token }
      });
      setCandidate(response.data);
    } catch (error) {
      console.error('Error loading candidate:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-100 via-gray-100 to-slate-200">
        <Loader2 className="w-12 h-12 animate-spin text-indigo-600" />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gradient-to-br from-slate-100 via-gray-100 to-slate-200">
      <div className="w-full max-w-2xl animate-slide-in">
        <Card className="shadow-premium border-0 glass" data-testid="completion-card">
          <CardHeader className="text-center pb-4">
            <div className="w-24 h-24 rounded-full bg-gradient-to-br from-green-500 to-emerald-600 flex items-center justify-center mx-auto mb-6 shadow-lg animate-bounce">
              <CheckCircle className="w-12 h-12 text-white" />
            </div>
            <CardTitle className="text-3xl mb-3" style={{fontFamily: 'Manrope'}}>
              Perfeito! 💡
            </CardTitle>
            <p className="text-lg text-gray-700">
              Sua avaliação foi concluída com sucesso!
            </p>
          </CardHeader>

          <CardContent className="space-y-6">
            <div className="bg-green-50 border border-green-200 rounded-lg p-6">
              <h3 className="font-semibold text-green-900 mb-3">
                O que acontece agora:
              </h3>
              <ul className="space-y-2 text-green-800">
                <li className="flex items-start">
                  <span className="mr-2">✓</span>
                  <span>Seu resultado foi calculado automaticamente com base no DISC</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">✓</span>
                  <span>A equipe de RH da DRSUPORTI já recebeu sua avaliação</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">✓</span>
                  <span>Você será contatado em breve sobre os próximos passos</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">✓</span>
                  <span>Seu perfil comportamental foi identificado e analisado</span>
                </li>
              </ul>
            </div>

            <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
              <h3 className="font-semibold text-blue-900 mb-2">
                Gostei do seu jeito de pensar 😉
              </h3>
              <p className="text-blue-800 text-sm">
                Cada perfil tem suas forças únicas. O time de RH vai avaliar como suas características se encaixam melhor nas oportunidades disponíveis na DRSUPORTI.
              </p>
            </div>

            <div className="text-center pt-4">
              <p className="text-sm text-gray-600 mb-2">
                Agradecemos por participar da nossa avaliação!
              </p>
              <p className="text-xs text-gray-500">
                Você pode fechar esta página agora.
              </p>
            </div>
          </CardContent>
        </Card>

        <p className="text-center text-sm text-gray-600 mt-6">
          © 2024 DRSUPORTI - Em caso de dúvidas, entre em contato com rh@drsuporti.com.br
        </p>
      </div>
    </div>
  );
}
